import { Box, Typography } from '@mui/material';
import React from 'react';

// Compact KPI tile: small label on top, large value with unit
const NumberLabel = ({
  label,
  value,
  unit,
  icon,
}) => {
  const hasValue = value !== null && value !== undefined;

  return (
    <Box sx={{
      display: "flex",
      flexDirection: "column",
      gap: 1,
      p: 2,
      borderRadius: "12px",
      backgroundColor: "var(--c-subtle)",
      border: "1px solid var(--c-muted)",
      minWidth: 0,
    }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, color: "var(--c-text-muted)" }}>
        {icon && React.cloneElement(icon, { sx: { fontSize: 16 } })}
        <Typography sx={{ fontSize: 12, fontWeight: 500, color: "var(--c-text-muted)", lineHeight: 1.2 }} noWrap>
          {label}
        </Typography>
      </Box>

      <Box sx={{ display: "flex", alignItems: "baseline", gap: 0.5 }}>
        <Typography sx={{
          fontSize: 32,
          fontWeight: 600,
          letterSpacing: "-0.02em",
          fontVariantNumeric: "tabular-nums",
          color: hasValue ? "var(--c-brand)" : "var(--c-border-strong)",
          lineHeight: 1,
        }}>
          {hasValue ? Number(value).toFixed(0) : "–"}
        </Typography>
        <Typography sx={{ fontSize: 15, fontWeight: 500, color: "var(--c-text-muted)", lineHeight: 1 }}>
          {unit}
        </Typography>
      </Box>
    </Box>
  )
}

export default NumberLabel;
